module.exports = __webpack_public_path__ + "static/media/nuvalez.2185cc50.png";